export default __webpack_public_path__ + "static/media/IMG_5360.805368fd.PNG";